import logoImage from '../assets/ethy-logo-fallback.svg';

/////////////////////////////////////////////////////////
// This file contains configs that affect branding     //
// NOTE: these are just some of the relevant configs   //
// Most of the work happens in marketplaceDefaults.css //
// and in components.                                  //
/////////////////////////////////////////////////////////

// Note: These come from the branding asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeBranding func)
//
// Everything in this file is a *fallback*: the real branding is configured in
// Sharetribe Console and merged over the top of these values in
// util/configHelpers.js (mergeBranding). These only show when the Console asset is
// missing or hasn't loaded - which is exactly the moment the site must not show
// another marketplace's logo, so the template's Biketribe artwork was removed.

// Marketplace color.
// This is saved as CSS Property: --marketplaceColor in src/app.js
// Also --marketplaceColorDark and --marketplaceColorLight are generated from this one
// by adding +/- 10% to lightness.
// NOTE: this is still the template's default. ethy's colour is set in Console; if you
// want a branded fallback here too, replace it with the hex from the brand guide.
export const marketplaceColor = '#7c3aed';

// Logo is used in Topbar on mobile and desktop, where height is the limiting factor.
// Therefore, we strongly suggest that your image file for desktop logo is in landscape!
//
// If you need to fine-tune the logo, the component is defined in src/components/Logo/Logo.js
// By default logo gets 24 pixels vertical space, but it could be wider (e.g. 180px)
//
// This is a plain wordmark standing in for the official artwork - see the note in the
// SVG itself. The same file is used on mobile and desktop because it scales cleanly.
export const logoImageDesktopURL = logoImage;
export const logoImageMobileURL = logoImage;

// The _logoSettings_ settings for the logo. Due to constraints in current Topbar, we only support 3 height variants
// at this point. There could be more height variants in the future and potentially other logo formats than 'image'.
// Note: logo image is always scaled and the limiting factor is height. However, there's also maximum width,
//       which is 370px in the Topbar. If the logo is wider than that, browser will scale it down.
export const logoSettings = {
  height: 24, // Hosted asset supports: 24, 36, 48
  format: 'image',
};

// brandImageURL would be the background image on the "hero" section of the login,
// email verification and password pages. mergeBranding takes that image from the
// Console asset only (`loginBackgroundImage`) and never falls back to this value, so
// there is nothing to ship here: with no Console image those pages render their plain
// background, which is the right neutral default.
export const brandImageURL = null;

// Default images for social media sharing.
// These can be overwritten per page, and are normally set in Console (branding asset,
// "social sharing image"). No fallback artwork is bundled: a marketplace-wide sharing
// image is a brand decision, and shipping the wrong one means every link posted to
// Facebook, WhatsApp or Slack carries it. With these unset, pages simply omit the
// og:image/twitter:image tags until Console provides one.

// For Facebook, the aspect ratio should be 1200x630 (otherwise, the image is cropped)
export const facebookImageURL = null;
// For Twitter, the aspect ratio should be 600x314 (otherwise, the image is cropped)
export const twitterImageURL = null;
